export default {
  appTitle: 'Registro | Wirecard',
  appHeader: {
    services: 'Servicios',
    company: 'Empresa',
    resources: 'Recursos'
  },
  appHead: {
    mainTitle: 'Acepte ahora tarjetas de crédito',
    subTitle: 'Regístrese en solo unos pasos para integrar Visa y <br>Mastercard en su tienda web',
    description: 'Por favor, tenga a mano una copia digital de su <strong>documento de identidad</strong>, su <strong>certificado de inscripción en el registro mercantil</strong> (no para sociedades unipersonales/autónomos) y un comprobante de su <strong>domicilio comercial</strong> actual. Le pediremos que suba estos documentos en el curso de su registro.'
  },
  aliasForm: {
    label: 'Por favor, introduzca su nombre',
    button: 'Inicie el registro',
    invalid: 'Por favor proporcione un nombre válido'
  },
  paymentMethods: 'Métodos de pago disponibles:',
  ecommerceSystems: 'Sistemas de comercio electrónico disponibles:',
  features: {
    title: 'Rapidez y seguridad en el procesamiento y pagos inmediatos',
    description: {
      p1: 'Las tarjetas de crédito son uno de los métodos de pago más populares en el ámbito del comercio electrónico.',
      p2: 'Con Wirecard, puede integrar fácilmente Visa y Mastercard en su tienda.',
      p3: 'Ofrézcales a sus clientes una forma de pago cómoda y segura y benefíciese de pagos inmediatos. Regístrese ahora: ¡solo le llevará unos minutos!'
    },
    feat1: 'Rapidez y seguridad en el procesamiento de los pagos para Visa y Mastercard (con 3D Secure)',
    feat2: 'Acceso a la cuenta en tiempo real y pagos inmediatos',
    feat3: 'Panel de control intuitivo con funciones de análisis integradas',
    feat4: 'Acceso a métodos de pago adicionales (próximamente)',
    feat5: 'Disponible para Magento 2, PrestaShop y WooCommerce (solo transacciones en euros)'
  },
  video: {
    title: 'Panel de control claro con una gama completa de funciones',
    description: 'Puede usar el panel de control para gestionar su cuenta de Wirecard y todas sus transacciones de una forma realmente sencilla. Consulte de un vistazo todas las actividades de su cuenta y acceda a toda una serie de análisis e informes que le ayudarán a optimizar su negocio. Para una vista detallada del panel de control y todas sus funciones, consulte nuestro tutorial.',
    button: 'Vea ahora el tutorial'
  },
  references: {
    title: 'Referencias',
    ref1: {
      content: '«Unas transacciones de pago seguras y sin problemas son absolutamente esenciales para nuestra plataforma. Podemos confiar en Wirecard al 100%.»',
      role: 'Fundador y director'
    },
    ref2: {
      content: '«Estábamos buscando una solución que pudiéramos integrar fácilmente en nuestra tienda y adaptarla a nuestras necesidades futuras.»',
      role: 'Fundador y director general'
    },
    ref3: {
      content: '«Con Wirecard, podemos procesar los pagos con tarjeta de crédito de nuestros clientes de forma rápida y segura. Todos los ingresos están disponibles de inmediato una vez que se realizan los pagos.»',
      role: 'Director'
    }
  }
}
